import React from 'react';
import { Slider as SliderMui, styled } from '@mui/material';

const CustomSlider = styled(SliderMui)(({ theme }) => {
    return {
        width: 100,
        mr: 1,
        '& .MuiSlider-thumb': {
            width: 12,
            height: 12,
            backgroundColor: 'white',
            border: '1.5px solid #44494d',
            '&:hover': {
                cursor: 'pointer',
                boxShadow: 'unset',
            },
            '&::before': {
                width: 4,
                height: 2,
                backgroundColor: 'white',
                left: -5,
                borderRadius: 'unset',
                boxShadow: 'unset',
            },
            '&::after': {
                width: 4,
                height: 2,
                backgroundColor: 'white',
                left: '11px',
                borderRadius: 'unset',
                top: '50%',
                transform: 'translateY(-50%)',
            },
        },
        '& .MuiSlider-rail': {
            backgroundColor: '#44494d',
            height: '2px',
        },
        '& .MuiSlider-track': {
            backgroundColor: '#44494d',
            border: 'none',
            height: '2px',
        },
    };
});

const Slider = (props) => {
    return <CustomSlider {...props} />;
};

export default Slider;
